// ตั้งค่าที่ต้องมีผลทั้งเว็บตั้งแต่เปิดหน้าแรก
// เดิมทุกหน้าถูก import พร้อมกันตอนเปิดเว็บ โค้ดบรรทัดบนสุดของบางหน้าจึงมีผลกับทั้งเว็บโดยไม่ตั้งใจ
// พอแยกโหลดทีละหน้า (lazy) ต้องย้ายมารวมไว้ตรงนี้ ไม่งั้นหน้าที่พึ่งพาอยู่จะพังจนกว่าจะเคยเปิดหน้านั้นก่อน
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/th";
import "moment/locale/th";

// เดิมอยู่ใน manage/car/car/manage-car.js — DatePicker ของ antd (components/field-control.js) รับค่าเป็น dayjs
// และเรียก .weekday() / .localeData() ข้างใน ทุกหน้าที่มีช่องวันที่จึงพึ่ง 2 บรรทัดนี้
dayjs.extend(weekday);
dayjs.extend(localeData);
